import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-qr-code-display',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="qr-content">
      <div *ngIf="isGeneratingQR" class="qr-loading">
        <div class="spinner"></div>
        <p>Generating QR Code...</p>
      </div>

      <div *ngIf="!isGeneratingQR && qrCodeData" class="qr-result">
        <div class="qr-code-wrapper">
          <img [src]="qrCodeData" alt="QR Code for NX2U App" class="qr-code-image" />
        </div>
                  <div class="qr-deeplink">
            <p><strong>Deep Link URL:</strong><br/><span class="instruction-text">(Click the link on your mobile device)</span></p>
          <div class="deeplink-url">
            <a [href]="deepLinkUrl" target="_blank" class="deeplink-link">{{ deepLinkUrl }}</a>
            <button type="button" class="copy-btn" (click)="copyDeepLink()" title="Copy to clipboard">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!isGeneratingQR && qrError" class="qr-error">
        <p>{{ qrError }}</p>
        <button type="button" class="retry-btn" (click)="onRetry.emit()">Try Again</button>
      </div>
    </div>
  `,
  styleUrls: ['./qr-code-display.component.scss']
})
export class QrCodeDisplayComponent {
  @Input() isGeneratingQR: boolean = false;
  @Input() qrCodeData: string | null = null;
  @Input() deepLinkUrl: string | null = null;
  @Input() qrError: string | null = null;
  @Output() onRetry = new EventEmitter<void>();

  copyDeepLink(): void {
    if (this.deepLinkUrl) {
      navigator.clipboard.writeText(this.deepLinkUrl).then(() => {
        console.log('Deep link copied to clipboard');
      }).catch(err => {
        console.error('Failed to copy deep link: ', err);
      });
    }
  }
} 